import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const GiftIcon: React.FC<NormalIconProps> = (props) => (
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
		<path
			d="M24.6667 13H1.33337M13 1.33331V24.6666M14.1667 13C14.1667 14.2377 14.6584 15.4246 15.5335 16.2998C16.4087 17.175 17.5957 17.6666 18.8334 17.6666M11.8334 13C11.8334 14.2377 11.3417 15.4246 10.4665 16.2998C9.59137 17.175 8.40438 17.6666 7.16671 17.6666"
			strokeWidth="1.75"
			strokeLinecap="round"
		/>
		<path
			d="M13.0001 10.7073C13.0001 9.86239 13.2826 9.04177 13.8027 8.37588C14.3227 7.70999 15.0504 7.23706 15.8701 7.03228C17.7403 6.56561 19.4354 8.25961 18.9676 10.1309C18.7628 10.9506 18.2899 11.6783 17.624 12.1984C16.9581 12.7184 16.1375 13.0009 15.2926 13.0009H13.0001M13.0001 10.7073V13.0009M13.0001 10.7073C13 9.86239 12.7176 9.04177 12.1975 8.37588C11.6775 7.70999 10.9498 7.23706 10.1301 7.03228C8.25993 6.56561 6.56476 8.25961 7.03259 10.1309C7.23737 10.9506 7.7103 11.6783 8.37619 12.1984C9.04208 12.7184 9.8627 13.0009 10.7076 13.0009H13.0001"
			strokeWidth="1.75"
		/>
		<path
			d="M1.33337 13C1.33337 7.50031 1.33337 4.75048 3.04137 3.04131C4.75171 1.33331 7.50037 1.33331 13 1.33331C18.4997 1.33331 21.2495 1.33331 22.9575 3.04131C24.6667 4.75165 24.6667 7.50031 24.6667 13C24.6667 18.4996 24.6667 21.2495 22.9575 22.9575C21.2507 24.6666 18.4997 24.6666 13 24.6666C7.50037 24.6666 4.75054 24.6666 3.04137 22.9575C1.33337 21.2506 1.33337 18.4996 1.33337 13Z"
			strokeWidth="1.75"
		/>
	</svg>
);
